import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

import transfersRoutes from "./TransfersRoutes";
import excursionsRoutes from "./ExcursionsRoutes";
import websiteRoutes from "./WebsitesRoutes";
import globalRoutes from "./GlobalRoutes";
import { loginStore } from "@/stores/LoginStore";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    ...transfersRoutes,
    ...excursionsRoutes,
    ...websiteRoutes,
    ...globalRoutes
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

router.afterEach((to, from) => {
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
    Vue.nextTick(() => {
        const title = (to.meta && to.meta.title) ? to.meta.title : "";
        if (title) {
            document.title = title + " | CRS | Intrabooking";
        } else {
            document.title = "CRS | Intrabooking";
        }
    });
});

router.beforeEach((to, from, next) => {
    const store = loginStore();
    if (!store.initialized) {
        store.initialize();
    }

    const authenticated = store.authenticated;
    const requiresAuth = (to.meta?.requiresAuth === false) ? false : true;

    // console.log("to", to);
    // console.log("requiresAuth", requiresAuth);
    // console.log("authenticated", authenticated);

    if (requiresAuth && !authenticated) {
        next({ name: "LogIn" });
        return;
    } else {
        next();
    }
});


export default router;
